export default __webpack_public_path__ + "static/media/mc_controls.edee6240.svg";